import React, { useRef, useEffect, useState, useCallback } from 'react';
import { Switch } from 'devextreme-react';
import AssetsService from "api/assets.service";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { useHistory } from "react-router";
import Toast from 'components/Toast';
import FeaturesService from "api/features.service";
import { el } from 'date-fns/locale';

export default function ActionsTab({ assetId, features }) {
    const [checkBoxValue, setCheckBoxValue] = useState(false);
    const [isPopupVisible, setisPopupVisible] = useState(false);
    const [isBeepVisible, setisBeepVisible] = useState(false);
    const [isCheckInOutVisible, setisCheckInOutVisible] = useState(false);
    // Ref to track if the initial data has been loaded into the state
    const isDataLoaded = useRef(false);
    const history = useHistory();

    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000,
    });

    useEffect(() => {
        // Only fetch once when the component mounts
        console.log("featues", features)
        console.log("features.checkInOut", features.checkInOut)
        if (features.checkInOut.isfeature) {
            if (!features.checkInOut.isDeviceFeature) {
                setisCheckInOutVisible(true)
            }
        }
        if (features.retrieval.isfeature) {
            if (!features.retrieval.isDeviceFeature) {
                isBeepVisible(true)
            } else {
                FeaturesService.getDeviceFeature(assetId, 1)
                .then((result) => {
                    let isDeviceFeature = result.data.data.has_feature
                    if (isDeviceFeature) {
                        setisBeepVisible(true);
                    } else {
                        setisBeepVisible(false);
                    }
                    // setIsLoading(false);
                })
                .catch((err) => {
                    console.error("Failed to fetch Device Feature", err);
                    // setIsLoading(false);
                });
            }
        }
        

    }, [assetId]); // Only re-run if the tenant changes

    useEffect(() => {
        getData();
    }, [assetId]);

    const getData = () => {
        AssetsService.getAsset(assetId).then((value) => {
            const data = value.data.data;
            if (data && data.info !== null) {
                // This update triggers onValueChanged, but our ref will block the API call
                setCheckBoxValue(data.info.checkInState.value);
                // Mark that we have finished the initial data setup
                isDataLoaded.current = true;
            }
        }).catch(err => {
            console.error("Fetch error:", err);
            isDataLoaded.current = true; // Still mark true so user can use switch if fetch fails
        });
    };

    const onValueChanged = useCallback((event) => {
        // If the data hasn't finished loading from the API, do nothing.
        // This prevents the command from firing when getData sets the initial state.
        if (!isDataLoaded.current) return;

        const newValue = event.value;

        // Note: No need for 'await' on setCheckBoxValue as it is synchronous in React's dispatch
        setCheckBoxValue(newValue);

        AssetsService.sendCommand(assetId, "CHECKIN", newValue, newValue).then((response) => {
            setToastConfig((prev) => ({
                ...prev,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response?.data?.status || response?.status,
                message: response?.data?.message || response?.message,
            }));

            // If it failed, revert the checkbox UI
            if (response.status !== 200) {
                setCheckBoxValue(!newValue);
            }
        });
    }, [assetId, toastConfig]);

    const wakeUpBtn = (isNotification) => {
        AssetsService.sendCommand(assetId, "WAKEUP", isNotification, isNotification).then((response) => {
            setToastConfig((prev) => ({
                ...prev,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response?.data?.status || response?.status,
                message: response.status === 200
                    ? 'Wake-Up Command Sent'
                    : 'Cannot Wake-Up asset.',
            }));
        });
    };

    const beepBtn = () => {
        AssetsService.sendCommand(assetId, "RETRIEVE").then((response) => {
            setToastConfig((prev) => ({
                ...prev,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response?.data?.status || response?.status,
                message: response.status === 200
                    ? 'Retrieve Command Sent'
                    : 'Cannot retrieve asset because no device paired to asset.',
            }));
        }).catch(() => {
            setToastConfig((prev) => ({
                ...prev,
                isVisible: true,
                type: 'error',
                status: 400,
                message: 'Cannot retrieve asset because no device paired to asset.',
            }));
        });
    };

    const manageBtn = (isNotifiedVal, isPopupVisibleVal) => {
        wakeUpBtn(isNotifiedVal);
        setisPopupVisible(isPopupVisibleVal);
        setTimeout(() => {
            history.push('/assets');
        }, 1000);
    };

    const acceptOptions = {
        text: 'Yes',
        onClick: () => manageBtn(true, false)
    };

    const rejectOptions = {
        text: 'No',
        onClick: () => manageBtn(false, false)
    };

    return (
        <div className='actions-container'>
            {isCheckInOutVisible && (
                <div className='assetTab-checkboxContainer'>
                    <div className='assetTab-checkboxText'>
                        Asset Checked &nbsp; &nbsp; OUT
                    </div>
                    <div className='assetTab-checkbox'>
                        <Switch
                            value={checkBoxValue}
                            onValueChanged={onValueChanged}
                            iconSize={39}
                            switchedOnText={"On"}
                            switchedOffText={"Off"}
                        />
                    </div>
                    <div className='assetTab-checkboxText'>
                        IN
                    </div>
                </div>
            )}
            <div className='ActionsPage'>
                {isBeepVisible && (
                    <div visible={isBeepVisible}>
                        <button className='profile-save' onClick={() => wakeUpBtn(true)}>WAKE UP</button>
                        <button className='profile-save' onClick={beepBtn}>RETRIEVE</button>
                    </div>
                )}
                <Popup
                    title="Confirm"
                    showTitle={true}
                    visible={isPopupVisible}
                    contentRender={() => <>Do you want to receive a notification when the device is ready for retrieval?</>}
                    onHiding={() => setisPopupVisible(false)}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    width={300}
                    height={"auto"}
                >
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="before"
                        options={acceptOptions}
                    />
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={rejectOptions}
                    />
                </Popup>
            </div>
            <Toast
                setParentToastConfig={setToastConfig}
                toastBody={toastConfig}
            />
        </div>
    );
}